import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { scrollToId } from "@/lib/api";

const LINKS = [
  { label: "Concept", id: "manifesto" },
  { label: "The Space", id: "features" },
  { label: "Points", id: "how-it-works" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        scrolled ? "border-b border-espresso/10 bg-cream/80 backdrop-blur-xl" : "border-b border-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-6 py-4 sm:px-10 sm:py-5">
        <button
          data-testid="nav-logo"
          onClick={() => scrollToId("top")}
          className="flex shrink-0 items-center gap-3 text-left"
        >
          <img
            src={`${process.env.PUBLIC_URL}/brand-mark.png`}
            alt="The Upper Room"
            className="h-9 w-auto sm:h-11"
          />
          <span className="flex flex-col">
            <span className="block whitespace-nowrap font-display text-lg font-medium leading-none tracking-tight text-espresso sm:text-xl">
              The Upper Room
            </span>
            <span className="mt-1 block font-body text-[10px] uppercase tracking-[0.25em] text-terracotta">
              Horizon Square
            </span>
          </span>
        </button>

        <div className="hidden items-center gap-10 md:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="link-underline font-body text-xs font-semibold uppercase tracking-[0.2em] text-stone transition-colors duration-300 hover:text-espresso"
            >
              {l.label}
            </button>
          ))}
        </div>

        <button
          data-testid="nav-waitlist-btn"
          onClick={() => scrollToId("waitlist")}
          className="shrink-0 whitespace-nowrap rounded-full bg-espresso px-4 py-2.5 font-body text-[11px] font-semibold uppercase tracking-[0.14em] text-cream transition-colors duration-300 hover:bg-[hsl(20_12%_25%)] sm:px-5 sm:text-xs sm:tracking-[0.18em]"
        >
          Register interest
        </button>
      </nav>
    </motion.header>
  );
};

export default Nav;
